<template>
    <div class="account-page" style="height: 100vh;">
   <!-- Main Wrapper -->
   <div class="main-wrapper">
    <div class="account-content">

        <div class="container">

            <!-- Account Logo -->
            <div class="account-logo">
                <router-link to="/index"><img src="@/assets/img/dkl.png" alt="Datenschutzkanzlei Lenz"></router-link>
            </div>
            <!-- /Account Logo -->

            <div class="account-box">
                <div class="account-wrapper">
                    <h3 class="account-title">Anmeldung</h3>
                    <p class="account-subtitle">Zugriff auf Mandant DSMS Tool</p>

                    <!-- Account Form -->
                    <form action="select-mandant" @submit.prevent="login" method="get">
                      <div class="">
                        <label v-if="errors.length || externalErrors.length" class="text-danger">
                          <ul class="list-unstyled">
                            <li v-for="externalError in externalErrors">{{externalError}}</li>
                            <li v-for="error in errors">{{error}}</li>
                          </ul>
                        </label>
                      </div>
                        <div class="form-group">
                            <label>Benutzername / Email Adresse</label>
                            <input class="form-control" type="text" v-model="username">
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col">
                                    <label>Password</label>
                                </div>
                                <div class="col-auto">
                                    <router-link class="text-muted" to="/forgot-password">
                                        Forgot password?
                                    </router-link>
                                </div>
                            </div>
                            <input class="form-control" type="password" v-model="password">
                        </div>
                        <div class="form-group text-center">
                            <button class="btn btn-primary account-btn" type="submit">Anmelden</button>
                        </div>
                    </form>
                    <!-- /Account Form -->

                </div>
            </div>
        </div>
    </div>
</div>
<!-- /Main Wrapper -->
</div>
<!-- /Main Wrapper -->
</template>
<script>
  import { mapActions } from 'vuex'
  import axios from 'axios'
  import service, { baseURL } from '@/utils/request'
  import md5 from 'blueimp-md5'

  export default {
    props: {
      externalErrors : {
        default() {
          return []
        },
        type: Array
      }
    },
    data() {
      return {
        errors: [],
        username: null,
        password: null
      }
    },
    methods: {
      ...mapActions(['fetchAccountByShortName']),
      async login(e) {
        this.errors = []
        if (!this.username) this.errors.push("Benutzername fehlt");
        if (!this.password) this.errors.push("Passwort fehlt")
        if (!this.errors.length) {
          await axios.post(baseURL + '/login/',{username: this.username, password: this.password})
            .then(response => {
              const hash = md5(`${this.password}_${this.username}`)
              this.$localStore.setItem(`${this.username}dsmsHash`, hash)
            if (response.data.hasOwnProperty('token')) {
              this.$store.commit('SET_TOKEN', response.data.token)
              this.$store.commit('SET_ID', response.data.id)
              this.$store.commit('SET_USERNAME', response.data.username)
              this.$store.commit('SET_NAME', response.data.name)
              this.$localStore.setItem(`${this.username}_name`, response.data.name)
              this.$store.commit('SET_AVATAR', response.data.avatar)
              fetch(response.data.avatar).then(response => response.blob()).then(blob =>
                this.$localStore.setItem(`${this.username}_avatar`, blob))
              this.$store.commit('SET_AUTHENTICATION', true)
              this.$router.push('select-mandant')
            } else this.errors.push(response.data.detail)
          }).catch(async error => {
            if (typeof error.response === 'undefined') {
                this.errors.push('Netzwerk Fehler. This could be a CORS issue or a dropped internet connection. It is not possible for us to know.')
                const hash = md5(`${this.password}_${this.username}`)
                const savedHash = await this.$localStore.getItem(`${this.username}dsmsHash`)
                if (hash === savedHash) {
                  this.$confirm(
                    {
                      message: 'Offline Modus möglich. Offline einlogin und arbeiten?',
                      button: {
                        no: 'Nein',
                        yes: 'Ja'
                      },
                      callback: async confirm => {
                        if (confirm) {
                          this.$store.commit('SET_USERNAME', this.username)
                          const name = await this.$localStore.getItem(`${this.username}_name`)
                          this.$store.commit('SET_NAME', name)
                          const urlCreator = window.URL || window.webitURL
                          const avatarBlob = await this.$localStore.getItem(`${this.username}_avatar`)
                          this.$store.commit('SET_AVATAR', urlCreator.createObjectURL(avatarBlob))
                          this.$store.commit('SET_AUTHENTICATION', true)
                          this.$router.push('select-mandant')
                        }
                      }
                    }
                  )
                }
              } else if (error.response.status === 400 && error.response.data.hasOwnProperty('non_field_errors')) {
              this.errors.push(error.response.data.non_field_errors[0])
              return false
            } else {
              this.errors.push(error.toString())
            }
          })
        }
        return false
      }
    }
  }
</script>
